import { attr, fk } from 'redux-orm'
import Base from './Base'

class InvoiceConfiguration extends Base {
  static get fields() {
    return {
      id: attr(),
      name: attr(),
      officeId: fk({ to: 'office', as: 'office', relatedName: 'invoiceConfiguration' }),
      enterpriseNumber: attr(),
      iban: attr(),
      invoiceConditions: attr(),
      invoiceMessage: attr(),
      startInvoiceIdentification: attr(),
      peppyrusApiKey: attr(),
      vatFree: attr(),
      scopeId: attr(),
      scopeType: attr()
    }
  }
}

InvoiceConfiguration.modelName = 'invoiceConfiguration'

export default InvoiceConfiguration;
